{
  "ui": {
    "feedback": "Ábendingar",
    "credits": "Aðstandendur",
    "currentMaintainer": "Núverandi umsjón",
    "maintainerPeriod": "Frá 2026",
    "originalTeam": "Upprunalega teymið",
    "creditsCampaigns": "Frumskógur og jól",
    "moreSettings": "Fleiri stillingar",
    "chooseLanguage": "Veldu tungumál",
    "notebookTools": "Verkfæri glósubókar",
    "visualGuide": "Myndaleiðbeiningar",
    "templeSoon": "Væntanlegt",
    "playAdventure": "Spila",
    "story": "Sagan",
    "loadingAdventure": "Við búum okkur undir ævintýrið…",
    "storyOpening": "Skólaferð inn í frumskóginn. Marco og Sophia kanna umhverfið með vinum sínum. Litríkur fugl vekur athygli Marcos og hann eltir hann inn á milli trjánna. Skyndilega er hann einn. Hjálpaðu landkönnuðunum að finna leiðina!",
    "storyEnding": "Marco og Sophia ná saman að týnda musterinu. Dularfullt andlit gætir inngangsins. Nýtt ævintýri bíður!",
    "blockCategories": "Flipar glósubókar",
    "actions": "Aðgerðir",
    "loops": "Lykkjur",
    "conditions": "Skilyrði",
    "title": "Run Marco! — Ævintýri í glósubókinni þinni",
    "home": "Forsíða Run Marco",
    "map": "Ævintýrakort",
    "worlds": "Veldu ævintýri",
    "notebook": "Glósubókin mín",
    "notebookToggle": "Opna eða loka glósubókinni",
    "notebookOpen": "Opna glósubók",
    "notebookClose": "Horfa á stíginn",
    "page": "Síða {number}",
    "level": "Leið {number}",
    "run": "Af stað!",
    "stop": "Stöðva",
    "step": "Eitt skref",
    "stepTitle": "Keyra eina skipun",
    "reset": "Aftur á byrjunarreit",
    "add": "Bæta við",
    "addLabel": "Veldu kubb til að bæta við",
    "addHint": "Tengdu kubbana og ýttu á Spila.",
    "undo": "Afturkalla",
    "clear": "Ný síða",
    "hint": "Lítil vísbending",
    "help": "Svona spilarðu",
    "settings": "Stillingar",
    "language": "Tungumál leiks",
    "blockLanguage": "Tungumál kubba",
    "blockLanguageNote": "Þú getur valið annað tungumál fyrir kubbana.",
    "musicOn": "Kveikja á hljóði",
    "musicOff": "Slökkva á hljóði",
    "sound": "Tónlist og hljóðbrellur",
    "speed": "Hraði ævintýris",
    "chooseExplorer": "Veldu landkönnuð",
    "explorer": "Landkönnuður",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Loka",
    "done": "Könnum heiminn!",
    "loading": "Við finnum stíginn…",
    "loadError": "Ekki tókst að hlaða ævintýrinu. Endurhladdu síðunni til að reyna aftur.",
    "imageError": "Ekki tókst að hlaða sumum myndum. Endurhladdu síðunni.",
    "gemGoal": "Finndu gimsteininn",
    "goal": "Finndu gullnu stjörnuna",
    "cover": "Lýstu upp hvern reit aðeins einu sinni",
    "lit": "Upplýstir reitir: {count} / {total}",
    "explored": "Kannaðar leiðir: {count} / {total}",
    "facing": "Horfir {direction} {arrow}",
    "boardLabel": "{name} á {level}, horfir {direction}. {steps}. {objective}.",
    "up": "upp",
    "down": "niður",
    "left": "til vinstri",
    "right": "til hægri",
    "steps_one": "{count} skref",
    "steps_other": "{count} skref",
    "blocks_one": "{count} kubbur",
    "blocks_other": "{count} kubbar",
    "stars_one": "{count} stjarna",
    "stars_other": "{count} stjörnur",
    "place": "Bæta við kubbum",
    "atEnd": "Í lokin",
    "insideRepeat": "Inni í endurtekningu {number}",
    "insideIf": "Inni í ef {number}",
    "insideElse": "Inni í annars {number}",
    "readyFirst": "Eitt lítið skref. Bættu við áfram-kubbi og leggjum af stað!",
    "ready": "Hvert förum við? Gerðu áætlun í glósubókinni.",
    "back": "Aftur á byrjunarreit. Kubbarnir eru tilbúnir fyrir nýja tilraun.",
    "empty": "Bættu fyrst kubbi í glósubókina.",
    "win": "Þú fannst leiðina!",
    "winCover": "Þú lýstir upp stíginn!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Þvílíkt ævintýri!",
    "simpler": "Geturðu notað færri kubba?",
    "complete": "Leið lokið! Bestu stjörnurnar þínar eru vistaðar.",
    "next": "Næsta leið",
    "allWorlds": "Fleiri ævintýri",
    "replay": "Spila aftur",
    "shortGoal": "Næstum því! Bættu við fleiri kubbum til að ná stjörnunni.",
    "shortGem": "Næstum því! Bættu við fleiri kubbum til að ná gimsteininum.",
    "shortCover": "Sumir reitir eru enn dimmir. Hvernig komumst við þangað?",
    "checking": "Við skoðum stíginn…",
    "paused": "Stöðvað. Spila byrjar aftur frá upphafi.",
    "going": "Nú förum við!",
    "stepped": "Einu skrefi nær. Ýttu á Eitt skref eða Spila til að halda áfram.",
    "clueCover": "Byrjaðu við jaðar og farðu eftir öllu forminu. Hopp fer yfir reit án þess að lýsa hann upp.",
    "clueCondition": "Skoðaðu stíginn fram undan. Skilyrði hjálpar landkönnuðinum að velja aðgerð.",
    "clueRepeat": "Hvaða skref endurtaka sig? Settu mynstrið inn í endurtekningarkubb.",
    "clueForward": "Áfram fylgir augnaráði landkönnuðarins. Teldu reitina að stjörnunni.",
    "clueGem": "Áfram fylgir augnaráði landkönnuðarins. Teldu reitina að gimsteininum.",
    "clueTurn": "Beygja breytir stefnu án þess að færa þig. Fylgdu stígnum með fingrinum.",
    "mapNote": "Veldu leið. Bestu stjörnurnar þínar varðveitast.",
    "mapLevel": "Leið {number}: {name}. {stars}.",
    "locked": "Ljúktu fyrri leiðinni til að opna þessa.",
    "soundBlocked": "Ýttu á hljóðhnappinn til að heyra ævintýrið.",
    "clearTitle": "Byrja á nýrri síðu?",
    "clearNote": "Kubbarnir fyrir þessa leið verða fjarlægðir. Afturkalla getur sótt þá aftur.",
    "keep": "Halda kubbunum mínum",
    "clearConfirm": "Eyða kubbum",
    "fresh": "Ný síða. Hvert leiðir næsta áætlun þín okkur?",
    "localProgress": "Framvinda þín er vistuð á þessu tæki.",
    "helpBuild": "Gerðu áætlun",
    "helpBuildText": "Dragðu kubba í glósubókina og tengdu þá eða ýttu á kubb til að bæta honum við. Veldu „Inni í endurtekningu“ fyrir skref í lykkju.",
    "helpTurn": "Fylgdu landkönnuðinum",
    "helpTurnText": "Áfram fylgir augnaráðinu. Vinstri og hægri snúa á staðnum. Hopp fer tvo reiti áfram.",
    "helpTry": "Prófaðu, horfðu og reyndu aftur",
    "helpTryText": "Ýttu á Spila fyrir áætlunina eða Eitt skref fyrir eina skipun. Bogna örin fer aftur á byrjunarreit og heldur kubbunum.",
    "helpWorlds": "Hvert ævintýri hefur markmið",
    "helpWorldsText": "Finndu gimsteininn í frumskóginum. Lýstu upp hvern lausan reit einu sinni í jólaævintýrinu. Ljúktu viðgerðum og sýnilegum markmiðum í musterinu og Eyjahafinu og komdu að útganginum.",
    "noTrail": "Þar er enginn stígur! Prófaðu að beygja fyrst.",
    "broken": "Þessi brú er brotin. Geturðu hoppað yfir hana?",
    "blocked": "Eitthvað er fyrir. Prófaðu hopp eða aðra leið.",
    "alreadyLit": "Þessi reitur er þegar upplýstur. Farðu aðeins einu sinni á hvern reit.",
    "loopError": "Áætlunin endurtekur sig endalaust. Prófaðu að breyta lykkjunni.",
    "repeatError": "Veldu fjölda endurtekninga frá 1 til 99.",
    "unsupported": "Fjarlægðu kubbinn sem er ekki studdur og reyndu aftur.",
    "connect": "Tengdu kubbana í eina keðju og ýttu á Spila.",
    "path": "stígur",
    "backpack": "Bakpoki",
    "templeGems": "Gimsteinar musterisins",
    "gemsCollected": "Gimsteinar: {count} / {total}",
    "gemsReady": "Allir gimsteinarnir eru komnir!",
    "aegeanTitle": "Leyndardómar Eyjahafsins",
    "harbour": "Höfn",
    "aegeanDescription": "Kannaðu höfnina: gerðu við stöðvar, endurnýttu undirforrit og sendu tölu með hverju verkefni.",
    "templeBetaNote": "Beta · Þrautir og kennsluefni eru í endurskoðun",
    "aegeanBetaNote": "Beta · Fyrstu 3 borðin í höfninni",
    "seasonal": "Árstíðabundið ævintýri",
    "choosePreview": "Veldu prufuborð",
    "repairs": "Viðgerðir",
    "reachExit": "Komdu að útganginum",
    "taskRequirements": "Markmið verkefnisins",
    "lessonGuided": "Leiðsögn · kláraðu tilbúna forritið",
    "lessonRepair": "Villuleit · lagfærðu tilbúna forritið",
    "lessonChallenge": "Áskorun · búðu til eigið forrit",
    "acc_define_parameter": "Undirforrit",
    "acc_call_argument": "Kalla á undirforrit",
    "acc_repeat_parameter": "Endurtaka með inntaki",
    "parameter": "stiki",
    "argument": "senda",
    "callInput": "Inntak þessa kalls",
    "inputWaiting": "Keyrðu forritið eða eina skipun í einu til að sjá næsta inntak.",
    "argumentMismatch": "Undirforrit með stika þarf kall með tölu. Án stika er notað venjulegt kall.",
    "unsetParameter": "Notaðu stikann aðeins inni í undirforritinu sem tekur við honum. Stikar eru aðskildir frá sameiginlegu minni.",
    "memoryObjective": "Athugaðu viðgerðaskrána og skilyrðin við útganginn. Öll forrit sem uppfylla þau eru samþykkt.",
    "gate": "Leiðin er lokuð. Athugaðu óloknar viðgerðir.",
    "noPickup": "Stattu á verkfærinu áður en þú tekur það upp.",
    "creditLead": "Teymisstjórn og hugbúnaðargerð",
    "creditArt": "Myndskreytingar og umhverfi",
    "creditAnimation": "Hreyfimyndir",
    "creditUX": "Viðmóts- og notendaupplifunarhönnun",
    "creditDesign": "Leikjahönnun",
    "creditStory": "Sögugerð",
    "creditAudio": "Tónlist og hljóðvinnsla",
    "lightLamp": "Kveikja á lampanum",
    "oilLamp": "Olíulampi",
    "dustyStation": "rykug stöð",
    "betaLabel": "Beta",
    "noLamp": "Stattu á slökktum lampa áður en þú kveikir á honum.",
    "collected": "Verkfæri tekið · tilbúið til notkunar",
    "dustyPrompt": "Stattu á rykugri stöð áður en þú notar pensilinn.",
    "lampMissing": "Taktu fyrst olíulampann. Skoðaðu bakpokann.",
    "recursiveRoutine": "Þetta undirforrit kallar á sjálft sig. Notaðu annað undirforrit; endurkvæm köll eru ekki enn í boði."
  },
  "content": {
    "jungle.title": "Frumskógarleiðangur",
    "jungle.description": "Fylgdu stígnum að týnda musterinu.",
    "jungle-1": "Fyrstu skrefin",
    "jungle-2": "Aðeins lengra",
    "jungle-3": "Fyrir hornið",
    "jungle-4": "Breyttu stefnu",
    "jungle-5": "Fylgdu stígnum",
    "jungle-6": "Ný leið",
    "jungle-7": "Nýir stígar",
    "jungle-8": "Vegamót í frumskóginum",
    "jungle-9": "Finndu leiðina",
    "jungle-10": "Hugsaðu fram í tímann",
    "jungle-11": "Langi stígurinn",
    "jungle-12": "Hlykkjótt leið",
    "jungle-13": "Hugrakkt stökk",
    "jungle-14": "Mynstur birtast",
    "jungle-15": "Endurtaktu taktinn",
    "jungle-16": "Veldu stíg",
    "jungle-17": "Horfðu áður en þú hoppar",
    "jungle-18": "Lestu stíginn",
    "jungle-19": "Snjöll hjáleið",
    "jungle-20": "Undir trjákrónunum",
    "jungle-21": "Brúarsmiður",
    "jungle-22": "Handan árinnar",
    "jungle-23": "Kannaðu rústirnar",
    "jungle-24": "Steinn og viður",
    "jungle-25": "Stærra hopp",
    "jungle-26": "Fylgdu vísbendingunum",
    "jungle-27": "Hærra upp",
    "jungle-28": "Haltu áfram að kanna",
    "jungle-29": "Hlykkjóttir stígar",
    "jungle-30": "Leyndargarðurinn",
    "jungle-31": "Falin mynstur",
    "jungle-32": "Fornir stígar",
    "jungle-33": "Síðustu beygjurnar",
    "jungle-34": "Að musterinu",
    "jungle-35": "Næstum komin",
    "jungle-36": "Týnda musterið",
    "winter.title": "Vetrarstígur",
    "winter.description": "Lýstu upp hvert fótspor.",
    "winter-1": "Skref í snjónum",
    "winter-2": "Önnur stefna",
    "winter-3": "Frosin horn",
    "winter-4": "Langa hjáleiðin",
    "winter-5": "Snjókorn",
    "winter-6": "Vetrarlykkjur",
    "winter-7": "Ískönnuður",
    "winter-8": "Beygjur og krókar",
    "winter-9": "Ísköld rökvísi",
    "winter-10": "Mynsturleitari",
    "winter-11": "Meistari stígsins",
    "winter-12": "Vetrarundur",
    "temple.title": "Týnda musterið",
    "temple.description": "Fjörutíu samtengd herbergi. Endurheimtu himintæki með verkfærum, minni og eigin undirforritum."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Ruslið er tómt",
    "OPEN_TRASH": "Opna ruslið",
    "BLOCK_LABEL_BEGIN_STACK": "Upphaf keðju",
    "WORKSPACE_LABEL_1_STACK": "1 kubbakeðja",
    "WORKSPACE_LABEL_MANY_STACKS": "Kubbakeðjur: %1",
    "ARIA_TYPE_FIELD_NUMBER": "tala",
    "ARIA_TYPE_FIELD_DROPDOWN": "fellilisti",
    "ARIA_TYPE_FIELD_IMAGE": "mynd",
    "WORKSPACE_LABEL_PLAIN": "Glósubókin mín",
    "FIELD_LABEL_EDIT_PREFIX": "Breyta %1",
    "BLOCK_LABEL_HAS_INPUT": "hefur inntak",
    "BLOCK_LABEL_HAS_INPUTS": "hefur inntök",
    "BLOCK_LABEL_HAS_BRANCHES": "greinar: %1",
    "FIELD_LABEL_OPTION_INDEX": "Valkostur %1",
    "INPUT_LABEL_EMPTY": "Tómt",
    "BLOCK_LABEL_DISABLED": "óvirkt",
    "BLOCK_LABEL_COLLAPSED": "fellt saman",
    "BLOCK_LABEL_BEGIN_PREFIX": "Upphaf: %1",
    "INPUT_LABEL_END_STATEMENT": "Endir: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "texti",
    "ARIA_TYPE_FIELD_INPUT": "inntak",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "heiti inntaks",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "heiti undirforrits"
  }
}
